import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import React from 'react'
import { useParams } from 'react-router-dom';
import { Axios } from '../../utils/Axios';
import Loading from '../Loading';
import NoContent from '../NoContent';
import { TbTrash } from 'react-icons/tb';
import toast from 'react-hot-toast';

function SubCategories() {
    const { id } = useParams();
    const queryClient = useQueryClient()


    const { data, isLoading } = useQuery({
        queryKey: [id],
        queryFn: async () => {
            const res = await Axios.get(`/category/subcategory/${id}`)
            return res?.data
        }
    })

    // delete subcategory
    const { mutate } = useMutation({
        mutationFn: (id) => {
            return Axios.delete('/category/subcategory', { params: { id } })
        },
        onSuccess: () => {
            toast.dismiss()
            toast.success("Deleted")
            queryClient.invalidateQueries([id])
        }
    })

    const deleteCat = (id) => {
        if (window.confirm("Are you sure you want to delete")) {
            mutate(id)
        }
        return;
    }


    if (isLoading) {
        return (
            <Loading />
        )
    }


    return (
        <div className='w-full relative'>
            {data && data?.length > 0 ? (
                <div className='w-full relative flex items-center flex-wrap gap-5'>
                    {data?.map((cat, i) => (
                        <div className="flex items-center bg-gray-50 p-4 rounded-lg max-w-[200px] w-full justify-between">
                            <div className=''>
                                <h4 className='text-sm'>{cat?.name}</h4>
                                <p className="text-xs text-gray-500">{cat?.Product?.length} product(s)</p>
                            </div>

                            <button className='text-red-500' onClick={() => deleteCat(cat?.id)}>
                                <TbTrash />
                            </button>
                        </div>
                    ))
                    }
                </div >
            ) : (
                <NoContent />
            )}
        </div >
    )
}

export default SubCategories